import { render } from "./ProductTableMenu.vue?vue&type=template&id=ba9faccc&scoped=true"
import script from "./ProductTableMenu.vue?vue&type=script&lang=js"
export * from "./ProductTableMenu.vue?vue&type=script&lang=js"

import "./ProductTableMenu.vue?vue&type=style&index=0&id=ba9faccc&scoped=true&lang=css"

import exportComponent from "/web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba9faccc"]])

export default __exports__